import { render, staticRenderFns } from "./VaDataTableStaticDataExample.vue?vue&type=template&id=797cb131&"
import script from "./VaDataTableStaticDataExample.vue?vue&type=script&lang=js&"
export * from "./VaDataTableStaticDataExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports